var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChildSeatReverse = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.066 7.383a2.995 2.995 0 0 1-.578-4.197 3.01 3.01 0 0 1 4.205-.58 2.995 2.995 0 0 1 .578 4.197 2.983 2.983 0 0 1-4.205.58Zm-2.355-3.94L7.54 16.958c.196 1.448 1.5 2.455 2.921 2.256l5.134-.722.236 1.744-5.134.722c-2.362.331-4.543-1.353-4.868-3.76L4 3.684l1.711-.24Zm9.352 11.57L20 18.825l-1.055 1.419-3.408-2.631-4.338.61c-1.42.199-2.725-.809-2.921-2.256l-.679-5.014c-.146-1.082.6-2.084 1.66-2.233l.026-.004c.29-.04.584-.002.848.085.237.074.463.193.65.354l1.38 1.183c1.046.893 2.82 1.434 4.238 1.217l.254 1.884c-1.625.228-3.627-.388-4.96-1.222l.433 3.209 2.935-.413Z",
  fill: "#1A1A1A"
})));
export default SvgChildSeatReverse;